<div class="ion-content animate__animated animate__fadeIn animate__faster">
  <div class="loading-spinner splash-image">
    <div class="center-bottom-spinner"><i class="fa-solid fa-circle-notch fa-spin"></i></div>
  </div>
</div>